<template>
  <div class='treeContent'>
    <div class='topContent'>
      <SearchTree @searchTree='searchTree' />
      <Tree ref='tree' v-bind='$attrs' @treeSearch='treeSearch' />
    </div>
    <div class='bottomContent'>
      <slot name='status-name'></slot>
      <SearchDevice v-bind='$attrs' @handleClick='handleClick' @searchDevie='searchDevie'
                    :checkTableData='checkTableData' :tableData='tableData' />
      <DeviceList v-bind='$attrs' :rightArray='rightArray' :tableData='tableData' v-load-more.expand="{
                func: searchMove,
                target: '.el-table__body-wrapper',
                delay: 100
            }" :load-more-disabled='noMoreFlag' @refreshList='refreshList' />
    </div>
    <!-- <el-button v-if="noMoreFlag" class="loadingMore">{{ $t('integration.no_more') }}</el-button>
    <el-button v-else class="loadingMore" @click="searchMove">{{ $t('integration.click_to_see_more') }}</el-button> -->
  </div>
</template>

<script>
import SearchTree from './top/SearchTree.vue'
import Tree from './top/Tree.vue'
import Tabs from './Tabs.vue'
import SearchDevice from './bottom/SearchDevice.vue'
import DeviceList from './bottom/DeviceList.vue'

export default {
  // props: ['deviceList', 'checkData'],
  props: {
    deviceList: {
      type: Array,
      default: () => []
    },
    checkData: {
      type: Array,
      default: () => []
    },
    noMoreFlag: {
      type: Boolean,
      default: false
    },
    rightArray: {}
  },
  watch: {
    deviceList (newVal) {
      this.tableData = [...newVal].map(item => {
        this.checkData.forEach(opt => {
          if (String(item.deviceId) === String(opt.deviceId)) {
            this.$set(item, 'isChooze', true)
          }
        })
        return item
      })
    }
  },
  components: {
    SearchTree,
    Tree,
    Tabs,
    SearchDevice,
    DeviceList
  },
  data () {
    return {
      tableData: [],
      checkTableData: []
    }
  },
  mounted () {
  },
  methods: {
    // handleTabs(row) {
    //     this.$emit('searchStatus', row.status)
    // },
    searchDevie (row) {
      this.$emit('searchDevie', row)
    },
    searchTree (value) {
      this.$refs.tree.$refs.tree.$refs.tree.filter(value)
    },
    searchMove () {
      this.$emit('searchMore')
    },
    handleClick (row) {
      this.allChooze = { ...row }
    },
    // tree查询
    treeSearch (row) {
      this.$emit('treeSearch', row)
    },
    refreshList () {
      this.tableData = [...this.tableData]
    }
  }
}
</script>

<style lang='scss' scoped>
.treeContent {
  width: 300px;
  height: 100%;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;

  .loadingMore {
    margin: 5px 0;
    position: absolute;
    left: 2px;
    right: 2px;
    bottom: 0;
  }

  .topContent,
  .bottomContent {

    width: 100%;
  }

  .topContent {
    max-height: 50%;
  }

  .bottomContent {
    margin-top: 10px;
    height: calc(50% - 10px);
    display: flex;
    flex: 1;
    flex-direction: column;
  }
}
</style>
